import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import type { FormSchema, GeneratedFile, Schema } from '@cli-types/core-engine/schema.js'
import type { SnapshotManifest } from '@cli-types/core-engine/snapshots.js'
import { BARREL_SCOPE } from '@cli-constants/snapshots.js'
import { runFormPipeline } from '@next-adapter/generators/form-pipeline/pipeline.js'
import { runEntityPipeline } from '@next-adapter/generators/run-entity-pipeline.js'
import { runSinglePipeline } from '@next-adapter/generators/run-single-pipeline.js'
import { renderBarrelFiles } from '@next-adapter/snapshots/barrels/render-barrel-files.js'

export function renderManifestFiles(
  cwd: string,
  config: ResolvedBetterstartConfig,
  manifest: SnapshotManifest
): GeneratedFile[] {
  if (manifest.schemaName === BARREL_SCOPE) {
    return renderBarrelFiles(cwd, config)
  }

  const schema = manifest.schemaJson
  if ('type' in schema && schema.type === 'form') {
    return runFormPipeline(schema as FormSchema, cwd, config, {
      force: true,
      silent: true
    }).files
  }

  if ('type' in schema && schema.type === 'single') {
    return runSinglePipeline(schema as Schema, cwd, config, {
      force: true,
      silent: true
    }).files
  }

  return runEntityPipeline(schema as Schema, cwd, config, {
    force: true,
    silent: true
  }).files
}
